import ChooseActivity from "@/Component/Common/ChooseActivity";
import CityExperiences from "@/Component/Common/CityExperiences";
import CustomerReviews from "@/Component/Common/CustomerReviews";
import DownloadNH from "@/Component/Common/DownloadNH";
import ExclusiveOffers from "@/Component/Common/ExclusiveOffers";
import HolidayPackageSection from "@/Component/Common/HolidayPackageSection";
import OfferBanner from "@/Component/Common/OfferBanner";
import SeeTheWorld from "@/Component/Common/SeeTheWorld";
import TopDeals from "@/Component/Common/TopDeals";
import MainLayout from "@/Component/MainLayout";
import { withRegionPath } from "@/utils/session";

function resolveOfferBtnUrl(url = "") {
  const trimmed = String(url || "").trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return withRegionPath(trimmed.startsWith("/") ? trimmed : `/${trimmed}`);
}

function mapOfferBannerItems(source) {
  if (!source) return null;

  const list = Array.isArray(source) ? source : [source];
  const mapped = list
    .map((item) => ({
      title: item?.title || "",
      subTitle: item?.subTitle || "",
      btnText: item?.btnText || "",
      btnUrl: resolveOfferBtnUrl(item?.btnUrl),
    }))
    .filter(
      (item) => item.title || item.subTitle || item.btnText || item.btnUrl
    );

  return mapped.length ? mapped : null;
}

export default function ActivityHome({
  initialFeaturedActivities = null,
  initialCitySpecificExperiences = null,
  initialChooseActivities = null,
  initialCouponList = null,
  initialSeasonalDeals = null,
  initialReviewsList = null,
  initialHomePageHeading = null,
  initialHomePageAdvertisement = null,
}) {
  const offerItems = mapOfferBannerItems(
    initialHomePageAdvertisement ?? initialHomePageHeading?.advertisement ?? null
  );

  return (
    <MainLayout
      headerBackgroundImage={initialHomePageHeading?.topBanner?.webImageUrl}
      headerMobileBackgroundImage={initialHomePageHeading?.topBanner?.mobileImageUrl}
    >
      <OfferBanner items={offerItems} />
      <TopDeals initialSeasonalDeals={initialSeasonalDeals} />
      <ExclusiveOffers initialCouponList={initialCouponList} defaultModuleId="2" />
      <ChooseActivity heading={initialHomePageHeading?.heading} initialData={initialChooseActivities} />
      <CityExperiences data={initialCitySpecificExperiences} />
      <HolidayPackageSection
        moduleType="activity"
        data={initialFeaturedActivities}
        hideWhenEmpty
      />
      <CustomerReviews
        moduleType="Activity"
        initialReviewsList={initialReviewsList}
      />
      <DownloadNH />
      <SeeTheWorld
        title={initialHomePageHeading?.heading?.title}
        text={initialHomePageHeading?.heading?.description}
      />
    </MainLayout>
  );
}
